/**
 * Backend User Types
 * Types for user data stored in the backend database
 */

export interface BackendUser {
  id: number;
  user_id: string;
  email: string;
  name: string | null;
  given_name: string | null;
  family_name: string | null;
  picture: string | null;
  is_active: boolean;
  is_verified: boolean;
  permissions: string[] | null;
  roles: string[] | null;
  last_login: string | null;
  login_count: number;
  created_at: string;
  updated_at: string | null;
}

export interface CreateUserRequest {
  user_id: string;
  email: string;
  name?: string;
  given_name?: string;
  family_name?: string;
  picture?: string;
  is_active?: boolean;
  is_verified?: boolean;
}

export interface GetUsersResponse {
  total: number;
  users: BackendUser[];
  limit: number;
  offset: number;
}

export interface GetUsersParams {
  limit?: number;
  offset?: number;
  is_active?: boolean;
  is_verified?: boolean;
}

/**
 * User API Error Types
 */
export enum UserErrorType {
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_ALREADY_EXISTS = 'USER_ALREADY_EXISTS',
  INVALID_DATA = 'INVALID_DATA',
  NETWORK_ERROR = 'NETWORK_ERROR',
  SERVER_ERROR = 'SERVER_ERROR',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export class UserApiError extends Error {
  type: UserErrorType;
  statusCode?: number;
  details?: any;

  constructor(type: UserErrorType, message: string, statusCode?: number, details?: any) {
    super(message);
    this.name = 'UserApiError';
    this.type = type;
    this.statusCode = statusCode;
    this.details = details;
  }
}
